<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'portfolio',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/portfolio/index', label: 'Investment portfolio' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/portfolio/Portfolio.Entry.vue